import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full max-w-8xl flex-col items-center justify-center px-4 py-20 text-center md:px-6 md:py-28">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-film-line text-4xl"></i>
      </span>
      <p className="mt-8 font-heading text-6xl font-black text-primary-500 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
        这个页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-500">
        你访问的页面可能已被移除或链接有误。
      </p>
      <p className="mt-2 rounded-md bg-background-100 px-3 py-1 font-label text-xs text-foreground-400">
        {location.pathname}
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-movie-line"></i>
          浏览电影
        </Link>
      </div>
    </div>
  );
}